export default "__VITE_ASSET__CDpmpDwO__"